var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "188px",
    height: "47px",
    viewBox: "0 0 188 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage_full",
    transform: "translate(-564.000000, -4419.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(564.000000, 4419.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 188 0 188 47 0 47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,46.0357617 L7.50194313,13.6390497 L18.983243,13.6390497 L14.0272323,36.3616259 L20.3642509,36.3616259 L18.4954508,46.4908907 L0,46.0357617 L0,46.0357617 Z M21.5302452,46.8401757 L28.7604796,13.6390497 L45.8492492,13.6390497 L47.0141738,46.8401757 L38.3473061,46.8401757 L37.4262775,41.1859926 L32.4980796,41.1859926 L30.8731756,46.8401757 L21.5302452,46.8401757 L21.5302452,46.8401757 Z M33.4458511,33.3080284 L37.6434306,33.3080284 L36.7234718,21.5180723 L33.4458511,33.3080284 Z M51.6449897,14.121698 L51.6449897,47 L69.2215514,47 L77.6434534,14.121698 L66.6478062,14.121698 L62.3143724,34.754915 L62.3143724,14.1756784 L51.6449897,14.121698 L51.6449897,14.121698 Z M74.1219366,46.7322148 L85.1710698,0 L102.665263,0 L113.878063,46.7322148 L101.014686,46.7322148 L99.8765043,39.5507037 L88.4219475,39.5507037 L88.1513084,46.7322148 L74.1219366,46.7322148 Z M90.9668102,28.672064 L97.3038288,28.672064 L94.2433612,10.6383741 L90.9668102,28.672064 Z M110.141533,13.6390497 L112.254229,24.2774237 L119.485533,24.5187479 L116.911788,46.7322148 L137.495331,46.7322148 L135.625462,37.0062155 L129.316256,37.0062155 L131.646105,13.6390497 L110.141533,13.6390497 L110.141533,13.6390497 Z M133.756662,13.8803738 L135.382635,23.8222948 L142.478085,23.8222948 L140.770813,46.3839883 L160.405515,46.3839883 L159.23952,36.9522351 L153.147468,36.9522351 L155.041941,14.3365612 L133.756662,13.8803738 Z M162.977121,13.8803738 L162.732155,46.7322148 L173.023926,46.7322148 L173.023926,41.3997973 L177.248249,41.3997973 L178.412104,46.7322148 L188,46.7322148 L181.445828,13.8803738 L162.977121,13.8803738 L162.977121,13.8803738 Z M172.103968,33.7631573 L176.301547,33.7631573 L173.269962,22.213467 L172.103968,33.7631573 Z",
    id: "Shape",
    fill: "#2E3E8F"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.ba483990e2525d112cf7840337ef6d14.svg";
export { ForwardRef as ReactComponent };